/** Feste URL fürs Regal-Schild (E11.6): /regal/:slug/:nummer → aktuelle Regalseite der Mieterin oder „gerade frei“ mit Warteliste. */
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { EmptyState, Seitenzustand } from "../ui";
import { Marke } from "../ui/Marke";
import { api, rufe } from "../api/client";
import { RechtlichesFuss } from "./Rechtliches";

interface Weiche {
  laden: { name: string; slug: string };
  nummer: string;
  belegt: boolean;
  mieternummer: string | null;
}

export function RegalWeiche() {
  const { slug = "", nummer = "" } = useParams();
  const navigate = useNavigate();
  const q = useQuery({ queryKey: ["public", "regalnummer", slug, nummer], queryFn: () => rufe<Weiche>(api.api.public.laden[":slug"].regalnummer[":nummer"].$get({ param: { slug, nummer } })), retry: false });
  useEffect(() => {
    if (q.data?.mieternummer) navigate(`/r/${slug}/${q.data.mieternummer}`, { replace: true });
  }, [q.data, slug, navigate]);
  return (
    <div className="app-public">
      <div className="app-public__card sc-center">
        <Seitenzustand query={q} lines={4}>
          {(d) =>
            d.mieternummer ? (
              <p className="sc-muted">Einen Moment …</p>
            ) : (
              <>
                <Marke size={48} />
                <h1 className="title">Regal {d.nummer} bei {d.laden.name}</h1>
                {d.belegt ? (
                  <EmptyState compact illustration="empty-shelf" title="Dieses Regal hat keine öffentliche Seite">Die Mieterin zeigt ihre Artikel nicht online. Schau einfach im Laden vorbei.</EmptyState>
                ) : (
                  <EmptyState compact illustration="empty-shelf" title="Dieses Regal ist gerade frei" action={<Link to={`/w/${d.laden.slug}`} className="rg-btn rg-btn--primary">Auf die Warteliste</Link>}>Lust, hier selbst zu verkaufen? Trag dich ein, der Laden meldet sich.</EmptyState>
                )}
                <RechtlichesFuss />
              </>
            )
          }
        </Seitenzustand>
      </div>
    </div>
  );
}
